

const values = [
  {
    icon: "ri-shield-flash-line",
    title: "Security First",
    body: "Every application we build places mobile security at its core. We integrate industry-leading encryption standards and privacy-by-design principles into our iOS development workflow.",
  },
  {
    icon: "ri-cpu-line",
    title: "Performance Driven",
    body: "We obsess over performance metrics. Our apps are optimized at every layer — from memory management to UI rendering — ensuring the smoothest possible experience on all supported iOS devices.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Clean Engineering",
    body: "Our code is modular, maintainable, and built to scale. We follow Apple's best practices and leverage the latest Swift and SwiftUI frameworks to deliver robust, future-proof applications.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centric Design",
    body: "Intuitive interfaces that feel native to iOS are our standard. We deeply study user behavior and iterate continuously to build experiences that users genuinely enjoy and rely on daily.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-20">
          <div className="max-w-lg">
            <span
              className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-gray-400 mb-5 border border-gray-200 px-3 py-1 rounded-full"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              About Us
            </span>
            <h2
              className="text-4xl md:text-5xl font-normal leading-tight text-gray-900"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              A Team Built for
              <br />
              <span className="italic">Modern iOS</span>
            </h2>
          </div>
          <div className="max-w-md lg:mb-2">
            <p className="text-gray-500 text-sm leading-7" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
              INTEROSMO P.C. was founded by a group of passionate iOS engineers and designers with a shared mission: to make mobile devices smarter, safer, and more efficient through exceptional app development.
            </p>
          </div>
        </div>

        {/* Split Layout: Image + Values */}
        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Left: Visual Card */}
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <div
              className="relative rounded-2xl overflow-hidden w-full"
              style={{ height: "480px", backgroundColor: "#1a2a1f" }}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/ac4c40217e5721316927a83aec9def6d.jpg"
                alt="INTEROSMO P.C. iOS development team"
                title="iOS development team at INTEROSMO P.C."
                className="w-full h-full object-cover object-top opacity-70"
              />
              {/* Overlay label */}
              <div className="absolute bottom-6 left-6 right-6 bg-black/50 backdrop-blur-sm rounded-xl p-4">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                  INTEROSMO P.C.
                </p>
                <p className="text-white/60 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
                  iOS Application Development — Metamorfosi, Attikis, Greece
                </p>
              </div>
            </div>
          </div>

          {/* Right: Values Grid */}
          <div className="w-full lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl p-6" style={{ backgroundColor: "#f9f8f6" }}>
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 mb-4">
                  <i className={`${v.icon} text-gray-600 text-base`}></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  <a id={`about-${v.title.toLowerCase().replace(/\s+/g, "-")}`} className="text-gray-900">
                    {v.title}
                  </a>
                </h4>
                <p className="text-xs text-gray-500 leading-6" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
                  {v.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
